import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-luxury-slate text-white pt-20 pb-10" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-55">
          {/* Brand Column */}
          <div className="col-span-1 lg:col-span-1" data-id="element-56">
            <h2 className="text-3xl font-italiana font-bold tracking-wider mb-6" data-id="element-57">
              Luxury Pads
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 font-light" data-id="element-58">
              Your gateway to the world's finest accommodations. Handpicked
              properties for the discerning traveler.
            </p>
            <div className="flex space-x-4" data-id="element-59">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-60">
                <Instagram className="w-5 h-5" data-id="element-61" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-62">
                <Facebook className="w-5 h-5" data-id="element-63" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-64">
                <Twitter className="w-5 h-5" data-id="element-65" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-66">
                <Linkedin className="w-5 h-5" data-id="element-67" />
              </a>
            </div>
          </div>

          {/* Explore Column */}
          <div data-id="element-68">
            <h3 className="text-lg font-semibold mb-6 font-poppins" data-id="element-69">Explore</h3>
            <ul className="space-y-4" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-72">
                  Hotels
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-74">
                  Villas
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-76">
                  Apartments
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-78">
                  Destinations
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-80">
                  Special Offers
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-81">
            <h3 className="text-lg font-semibold mb-6 font-poppins" data-id="element-82">Support</h3>
            <ul className="space-y-4" data-id="element-83">
              <li data-id="element-84">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-85">
                  Help Center
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-87">
                  Contact Us
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-89">
                  Cancellation Options
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-91">
                  Trust & Safety
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div data-id="element-92">
            <h3 className="text-lg font-semibold mb-6 font-poppins" data-id="element-93">
              Newsletter
            </h3>
            <p className="text-gray-400 text-sm mb-4 font-light" data-id="element-94">
              Subscribe for exclusive offers and travel inspiration.
            </p>
            <form className="flex flex-col space-y-3" data-id="element-95">
              <input type="email" placeholder="Your email address" className="bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-luxury-blue transition-colors" data-id="element-96" />
              <button type="button" className="bg-luxury-blue hover:bg-blue-600 text-white rounded-lg px-4 py-3 text-sm font-semibold transition-colors" data-id="element-97">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-98">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-99">
            &copy; {new Date().getFullYear()} Luxury Pads. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-100">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-101">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-102">
              Terms of Service
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-103">
              Cookie Settings
            </a>
          </div>
        </div>
      </div>
    </footer>;
}